<template>
  <section>
    <div class="area_pantalla">
      <div class="scroll_vertical">
        <div style="height: 20%"></div>

        <center>
          <div style="width: 77%; max-width: 400px">
            <img style="width: 80%; max-width: 300px" src="@/assets/logo-rackon2-w-contorno-eq.svg" />

            <div class="mt-10 text-h6" style="color: #bead87">Inicio de sesión</div>
            <div class="mt-2">
              ¿No tienes una cuenta?
              <router-link to="/registro">Regístrate</router-link>
            </div>

            <v-form v-on:submit.prevent v-model="permitirEntrar">
              <v-text-field
                class="mt-7"
                ref="email"
                label="Correo electrónico"
                prepend-inner-icon="mdi-email"
                :rules="[rvEmailValido]"
                validate-on-blur
                v-model="email"
                @keyup.enter="$refs.contrasena.focus()"
              ></v-text-field>

              <v-text-field
                ref="contrasena"
                label="Contraseña"
                prepend-inner-icon="mdi-account-key"
                v-model="password"
                :type="mostrarPassword ? 'text' : 'password'"
                :append-icon="mostrarPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="mostrarPassword = !mostrarPassword"
                @keyup.enter="permitirEntrar && entrar()"
              ></v-text-field>

              <div class="mt-1" align="left">
                <router-link :to="{path: '/olvideMiContrasena', query: { email: email }}" class="nav-link">Olvidé mi contraseña</router-link>
              </div>

              <v-btn
                class="mt-5"
                ref="entrar"
                :disabled="!permitirEntrar"
                elevation="2"
                style="mt-20"
                color="pink darken-4"
                @click="entrar()"
              >Entrar</v-btn>
            </v-form>
          </div>
        </center>

        <v-dialog v-model="cuadroEmergente.mostrar" max-width="400">
          <v-card light>
            <v-card-title class="headline"><v-icon color="#303030" x-large class="mr-2" v-html="cuadroEmergente.icono"></v-icon><span v-html="cuadroEmergente.titulo"></span></v-card-title>
            <v-card-text><span v-html="cuadroEmergente.texto"></span></v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary darken-1" text @click="cuadroEmergente.accion()">Aceptar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <span v-if="$global.deviceInfo.platform == 'web'">
          <center class="mt-8">
            <a href="https://play.google.com/store/apps/details?id=com.equinsanetworking.rackon&gl=ES"><img style="width: 40%; max-width: 150px" src="@/assets/download-android.png" /></a>
          </center>
        </span>

        <div style="height: 40px"></div>
      </div>
    </div>
  </section>
</template>

<script>
import * as Validadores from "@/validadores.js"
import {deshabilitarAutocompletado} from "@/util.js"

export default {
  name: "Inicio",
  data: () => ({
    permitirEntrar: false,
    email: "",
    password: "",
    mostrarPassword: false,
    cuadroEmergente: {
      mostrar: false,
      titulo: "",
      texto: ""
    }
  }),

  methods: {
    rvValorNoVacio(valor) {
      return Validadores.esValorNoVacio(valor) || "Requerido";
    },
    rvEmailValido(valor) {
      return Validadores.esEmailValido(valor) || "Email no válido";
    },
    rvPasswordValido(valor) {
      return valor.length > 5 || "Mínimo 6 caracteres";
    },

    entrar() {
      this.$global.cargando = true;
      this.$store
        .dispatch("INICIAR_SESION", {
          email: this.email,
          password: this.password
        })
        .catch(e => {
          console.log(e);
          this.cuadroEmergente.icono = "mdi-emoticon-confused-outline";
          this.cuadroEmergente.titulo = "Error de inicio de sesión";
          this.cuadroEmergente.texto = e.response.data.error
            ? e.response.data.error
            : e;
          this.cuadroEmergente.accion = () => { this.cuadroEmergente.mostrar = false };
          this.cuadroEmergente.mostrar = true;
        })
        .finally(() => {
          this.$global.cargando = false;
        });
    }
  },

  mounted() {    
    this.$refs.contrasena.reset();    
    deshabilitarAutocompletado(document);
    if (this.$global.deviceInfo.platform == "web") this.$refs.email.focus();
  }
};
</script>

<style scoped>
</style>